import React, { useEffect, useState, useContext } from "react";
import "./DataForm.css";
import InputText from "../../../shared/components/Inputs/InputText";
import { Input, Button, Radio } from "antd";

import { round } from "lodash";

import { Store } from "../../../store";
import {updateLayoutObject } from "../../../services/layoutObjectsService";
import { unitsToPixels, pixelsToUnits, binHandler, generateBins } from "../../../utils/helpers";

//Router
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const DataForm = (props) => {
  const location = useLocation();
  const { data, dataViewElements, mode, type, onCloseDrawer } = props;
  const { state, dispatch } = useContext(Store);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [_selectedLevel, setSelectedLevel] = useState(null);

  const rackObject = [
    {
      id: 1,
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Name",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 2,
      name: "code",
      type: "text",
      label: "Code",
      placeholder: "Code",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 3,
      name: "positionX",
      type: "number",
      label: "PositionX",
      placeholder: "PositionX",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 4,
      name: "positionY",
      type: "number",
      label: "PositionY",
      placeholder: "PositionY",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 5,
      name: "width",
      type: "number",
      label: "Width",
      placeholder: "width",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 6,
      name: "length",
      type: "number",
      label: "Height",
      placeholder: "Length",
      isDisabled: true,
      isDisplay: true,
    },
  ];

   const areaObject = [
    {
      id: 1,
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Name",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 2,
      name: "code",
      type: "text",
      label: "Code",
      placeholder: "Code",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 3,
      name: "positionX",
      type: "number",
      label: "PositionX",
      placeholder: "PositionX",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 4,
      name: "positionY",
      type: "number",
      label: "PositionY",
      placeholder: "PositionY",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 5,
      name: "width",
      type: "number",
      label: "Width",
      placeholder: "width",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 6,
      name: "length",
      type: "number",
      label: "Height",
      placeholder: "Length",
      isDisabled: true,
      isDisplay: true,
    },
  ];

   const wallObject = [
    {
      id: 1,
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Name",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 2,
      name: "code",
      type: "text",
      label: "Code",
      placeholder: "Code",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 3,
      name: "positionX",
      type: "number",
      label: "PositionX",
      placeholder: "PositionX",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 4,
      name: "positionY",
      type: "number",
      label: "PositionY",
      placeholder: "PositionY",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 5,
      name: "width",
      type: "number",
      label: "Width",
      placeholder: "width",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 6,
      name: "length",
      type: "number",
      label: "Height",
      placeholder: "Length",
      isDisabled: true,
      isDisplay: true,
    },
  ];

    const subAreaObject = [
    {
      id: 1,
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Name",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 2,
      name: "code",
      type: "text",
      label: "Code",
      placeholder: "Code",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 3,
      name: "positionX",
      type: "number",
      label: "PositionX",
      placeholder: "PositionX",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 4,
      name: "positionY",
      type: "number",
      label: "PositionY",
      placeholder: "PositionY",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 5,
      name: "width",
      type: "number",
      label: "Width",
      placeholder: "width",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 6,
      name: "length",
      type: "number",
      label: "Height",
      placeholder: "Length",
      isDisabled: true,
      isDisplay: true,
    },
  ];

 
  const binObject = [
    {
      id: 1,
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Name",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 2,
      name: "code",
      type: "text",
      label: "Code",
      placeholder: "Code",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 3,
      name: "positionX",
      type: "number",
      label: "PositionX",
      placeholder: "PositionX",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 4,
      name: "positionY",
      type: "number",
      label: "PositionY",
      placeholder: "PositionY",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 5,
      name: "width",
      type: "number",
      label: "Width",
      placeholder: "width",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 6,
      name: "length",
      type: "number",
      label: "Height",
      placeholder: "Length",
      isDisabled: true,
      isDisplay: true,
    },
  ];

  const dockObject = [
    {
      id: 1,
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Name",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 2,
      name: "code",
      type: "text",
      label: "Code",
      placeholder: "Code",
      isDisabled: false,
      isDisplay: true,
    },
    {
      id: 3,
      name: "positionX",
      type: "number",
      label: "PositionX",
      placeholder: "PositionX",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 4,
      name: "positionY",
      type: "number",
      label: "PositionY",
      placeholder: "PositionY",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 5,
      name: "width",
      type: "number",
      label: "Width",
      placeholder: "width",
      isDisabled: true,
      isDisplay: true,
    },
    {
      id: 6,
      name: "length",
      type: "number",
      label: "Height",
      placeholder: "Length",
      isDisabled: true,
      isDisplay: true,
    },
  ];

  // const subBins = [
  //   {
  //     id: 1,
  //     name: "name",
  //     type: "text",
  //     label: "Name",
  //     placeholder: "Enter Name",
  //     isDisabled: false,
  //     isDisplay: true,
  //   },
  //   {
  //     id: 2,
  //     name: "code",
  //     type: "text",
  //     label: "Code",
  //     placeholder: "Enter Code",
  //     isDisabled: false,
  //     isDisplay: true,
  //   },
  // ];

  //Form Fields Object By Type
  const elementMapping = {
    rack: rackObject,
    area:areaObject,
    wall:wallObject,
    subArea:subAreaObject,
    bin: binObject,
    dock: dockObject,
    // generateBins: generateBinsObject,
  };

  const unitTypeChange = (unit) => {
    // if unit type is changing, update with new config
    if (formData.unitType !== unit) {
      // get the pixels version of current unit type

      let { positionX, positionY, width, length, unitType: currentUnitType } = formData;
      positionX = unitsToPixels(positionX, currentUnitType);
      positionY = unitsToPixels(positionY, currentUnitType);
      width = unitsToPixels(width, currentUnitType);
      length = unitsToPixels(length, currentUnitType);

      positionX = round(positionX, 2);
      positionY = round(positionY, 2);
      width = round(width, 2);
      length = round(length, 2);
      // convert the pixels into new units

      positionX = round(pixelsToUnits(positionX, unit), 2);
      positionY = round(pixelsToUnits(positionY, unit), 2);
      width = round(pixelsToUnits(width, unit), 2);
      length = round(pixelsToUnits(length, unit), 2);

      const newFormData = {
        ...formData,
        unitType: unit,
        positionX,
        positionY,
        width,
        length,
      };
      setFormData(newFormData);
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const onRadioChanges = (e) => {
    setFormData({ ...formData, unitType: e.target.value });
    unitTypeChange(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let payload = {};
    if (mode === "edit") {
      onEdit(type);
    } else if (mode === "create") {
      onCreate(type);
    }
  };

  const onCreate = (objectType) => {
    let payload = {};
    const _objectType = objectType === "generateBins" ? "generateBins" : objectType;
    switch (_objectType) {
      case "bin":
        const rack = dataViewElements.find((element) => element.id === data.rackId);
        payload = binHandler(rack, formData, _selectedLevel);
        onSave(payload, "Bin Created Successfully");
        break;
      case "generateBins":
        const generatedBins = generateBins(data, formData?.levels, formData?.columns, formData?.binWidth, formData?.binHeight);
        payload = {
          ...data,
          levels: generatedBins?.levels,
          columns: generatedBins?.columns,
        };
        onSave(payload, "Bins Generated Successfully");
        break;
    }
  };


  const onEdit = (objectType) => {
    let payload = {};
    //let rack = dataViewElements.find((element) => element?.id === data?.rackId);
    switch (objectType) {
      case "rack":
        payload = { ...data, ...formData };

        onSave(payload, "Rack Updated Successfully");
        break;
      case "bin":
        const updatedBins = dataViewElements?.selectedParentRecord?.bins?.map((bin) => {
          if (bin?.id === data?.id) {
            return { ...data, ...formData };
          }
          return bin;
        })
        payload = { ...dataViewElements?.selectedParentRecord, bins: updatedBins,prevCode:data.code };
        onSave(payload, "Bin Updated Successfully");
        break;
      case "area":
        payload = { ...data, ...formData };
        onSave(payload, "Area Updated Successfully");
        break;
      case "subArea":
        //payload = { ...data, ...formData };
        const area = dataViewElements?.parentTableRecords?.find((element) => element?.id === data?.areaId);
        const updatedSubArea = area?.subAreas?.map((subArea) => {
          if (subArea?.id === data?.id) {
            return { ...data, ...formData, prevCode:data.code };
          }
          return subArea;
        })
        payload = { ...area, subAreas: updatedSubArea };
        onSave(payload, "SubArea Updated Successfully");
        break;
      case "wall":
        payload = { ...data, ...formData };
        onSave(payload, "Wall Updated Successfully");
        break;
      case "dock":
        payload = { ...data, ...formData };
        onSave(payload, "Dock Updated Successfully");
        break;
    }
  };

  const onSave = async(payload, successMsg) => {

    // console.log('data log => ',data);
    // console.log('payload => ',payload);

    //let payload = data;
    setLoading(true);
    try{

      //  console.log('## selectedRowData =>', data);
      //  console.log('## editedFormData =>', formData);

       const responseData = await updateLayoutObject({...data,...formData,prevCode:data.code});

      //  console.log('## responseData =>', responseData.data);

      
       

      // const response = await onSaveLayoutObject(location.state.warehouseLayoutId, payload, successMsg);
      
        const elementIndex = state.elements.findIndex((element) => element?.id === payload?.id);
        const elementReplacePaylod = { elementIndex, data: payload };
        dispatch({ type: "REPLACE_ELEMENT", payload: elementReplacePaylod });
        
       
        setLoading(false);
        onCloseDrawer();

        if(responseData.data){
        toast.success(successMsg, { autoClose: 1000 });
        }


    }catch(error){
      console.log('error', error);
        const {response: {data: { message }}} = error;
        const defaultErrorMessage = "Oops Something went wrong";
        toast.error(message || defaultErrorMessage);
        setLoading(false);
    }
  };





  useEffect(() => {
    let form_data = {};
    if(!props?.data) return;
    if (mode === "edit") {
      if(['rack','wall','area','dock'].includes(type)){
        form_data = props.data;
      }else if(['subArea','bin'].includes(type)){
        //form_data = { id, name, code, positionX, positionY, width, height, unitType };
        form_data = {...props.data,length:props.data.height}
      }
      setFormData(form_data);
    }
  }, [props]);
  return (
    <div className="data-form">
      <div className="inputs-wrapper">
        {elementMapping[type]?.map((item) => {
          return (
            <div className="data-form-container" style={{ display: item.isDisplay ? "block" : "none" }}>
              <div className="input-group-wrapper">
                <div className="input-label">
                  <label htmlFor={item.name}>{item.label}</label>
                </div>
                <div className="input-wrapper">
                  <Input
                    id={item["name"]}
                    placeholder={item["placeholder"]}
                    disabled={item.isDisabled}
                    value={formData[item["name"]]}
                    name={item.name}
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          );
        })}
        {/* {type === "rack" && (
          <div className="rack-input-group">
            <label className="rack-label">Unit Type</label>
            <div className="rack-input">
              <Radio.Group onChange={onRadioChanges} value={formData.unitType}>
                <Radio value={"inch"}>Inch</Radio>
                <Radio value={"feet"}>Feet</Radio>
              </Radio.Group>
            </div>
          </div>
        )} */}

        {/* <div style={{ width: "100%", display: (type === "bin" && mode === "create") ? "block" : "none" }}>
          
          {formData.width === _selectedLevel?.levelWidth ? (
            <span
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "14px",
                textAlign: "center",
                display: "block",
              }}
            >
              No Available width left
            </span>
          ) : (
            <span
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "14px",
                textAlign: "center",
                display: "block",
              }}
            >
              {formData?.width
                ? Number(formData?.width) > round(_selectedLevel?.availableLevelWidth)
                  ? "Given value exceed level width"
                  : `${mode === "edit" ? _selectedLevel?.availableLevelWidth : round(_selectedLevel?.availableLevelWidth - formData.width, 2)} Width Available`
                : `${round(_selectedLevel?.availableLevelWidth,2)} Width Available`}
            </span>
          )}
        </div> */}

        <div className="data-form-actions">
          <Button type="primary" size="medium" onClick={onCloseDrawer}>
            Cancel
          </Button>
          <Button type="primary" size="medium" onClick={onSubmit} loading={loading} iconPosition={"end"}>
            {mode === "create" ? (type === "generateBins" ? "Generate" : "Create") : " Update"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DataForm;
